import React from "react";

export interface CardData {
  title: React.ReactNode;
  body: React.ReactNode;
  footnote?: React.ReactNode;
}

interface CardsSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro?: React.ReactNode;
  columns: 2 | 3;
  cards: CardData[];
}

/**
 * Heading plus a grid of simple prose cards — objection handling, proof points, and other
 * short parallel arguments. Card titles support <em> for the serif accent; the optional
 * footnote renders as a monospace annotation (e.g. a pending-content marker).
 */
const CardsSection: React.FC<CardsSectionProps> = ({ id, eyebrow, heading, intro, columns, cards }) => {
  return (
    <section id={id} className="cs-section cs-cards">
      <div className="cs-cards-inner">
        <div className="cs-cards-head">
          <div className="eyebrow">{eyebrow}</div>
          <h2>{heading}</h2>
          {intro && <p>{intro}</p>}
        </div>

        <div className={`cs-cards-grid cs-cards-grid-${columns}`}>
          {cards.map((card, index) => (
            <article key={`cards-item-${index + 1}`} className="cs-card">
              <h3>{card.title}</h3>
              <p>{card.body}</p>
              {card.footnote && <div className="cs-card-footnote">{card.footnote}</div>}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
